import Vue from 'vue';
import App from '@/App.vue';
import '@/registerServiceWorker';
import router from '@/router';
import store from '@/store';
import vuetify from '@/plugins/vuetify';

import { preventTwoFinger, preventDoubleTap } from '@/common/util/control';

// スマホ操作制御
preventTwoFinger();
preventDoubleTap();

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
